import {ChangePasswordFormData} from 'interfaces';

import {createAction} from '@reduxjs/toolkit';

export const changePassword =
  createAction<ChangePasswordFormData>('changePassword');
export const changePasswordSuccess = createAction('changePasswordSuccess');
export const changePasswordFailure = createAction('changePasswordFailure');
